export enum CreativeName {
    NavigationBanner = 'Navigation_Banner',
}

export enum PromotionType {
    Dynamic = 'dynamic',
}
